<template>
  <!-- Header -->
  <div class="d-flex flex-wrap justify-between align-center mb-10" style="gap: 10px">
    <div class="d-flex align-center" style="gap: 8px">
      <v-btn
        variant="text"
        size="small"
        prepend-icon="mdi-arrow-left"
        class="text-grey-darken-2"
        @click="$router.push('/account-admin')"
      >
        Back
      </v-btn>
      <h1 style="margin: 0">Add New Account</h1>
    </div>
  </div>

  <!-- Form fields -->
  <v-form ref="formRef" class="mb-16">
    <div class="image-box">
      <label for="fileInput" class="image-div">
        <img :src="formFields.image || logoPlaceholder" class="bg-logo" alt="logo" />
        <span class="plus-icon">+</span>
      </label>
    </div>
    <div class="file-input-field">
      <v-file-input
        label="Account Logo"
        id="fileInput"
        accept="image/png, image/jpeg, image/jpg"
        show-size
        @update:modelValue="handleFileChange"
      />
    </div>
    <v-container>
      <br />

      <v-row>
        <v-col cols="12" md="6">
          <label for="">Account Name*</label>

          <v-text-field
            v-model.trim="formFields.accountName"
            label="Account Name*"
            required
            @update:modelValue="
              (value) => (formFields.accountName = value.toLowerCase().replace(/[-\s]/g, '_'))
            "
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label for="">Account Name Friendly*</label>

          <v-text-field
            v-model="formFields.accountNameFriendly"
            label="Account Name Friendly"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="12">
          <label for="">Initials*</label>

          <v-text-field v-model="formFields.initials" label="Initials*" required></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12" md="12">
          <label for="">Country*</label>

          <v-select
            v-model="formFields.countryCode"
            :items="filteredCountries"
            item-title="name"
            item-value="code"
            label="Select a country*"
            persistent-hint
            single-line
            clearable
            filterable
            :no-data-text="'No matching country found'"
            :hint="
              formFields.countryCode
                ? formFields.countryCode
                : selectedCountry
                  ? `${selectedCountry?.name} &nbsp;${selectedCountry?.code}`
                  : ''
            "
          >
            <template v-slot:prepend-item>
              <v-text-field
                v-model="searchQuery"
                label="Search Country"
                clearable
                dense
                autofocus
              ></v-text-field>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="mb-3">
        <v-col>
          <label for="">State*</label>

          <v-select
            v-model="formFields.stateCode"
            :items="filteredStates"
            item-title="name"
            item-value="code"
            label=""
            persistent-hint
            single-line
            clearable
            filterable
            :no-data-text="'No matching country found'"
            :hint="
              formFields.stateCode
                ? formFields.stateCode
                : selectedState
                  ? `${selectedState.name} &nbsp;${selectedState?.code}`
                  : ''
            "
          >
            <template v-slot:prepend-item>
              <v-text-field
                v-model="searchQueryStates"
                label="Search States"
                clearable
                dense
                autofocus
              ></v-text-field>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col>
          <label for="">Timezone</label>

          <v-select
            v-model="formFields.timezone"
            :items="filteredTimezones"
            item-title="label"
            item-value="value"
            label="Timezone*"
            persistent-hint
            single-line
            clearable
            filterable
            :no-data-text="'No matching timezone found'"
            :hint="formFields.timezone || 'Select timezone'"
          >
            <template v-slot:prepend-item>
              <v-text-field
                v-model="timezoneSearchQuery"
                label="Search Timezones"
                clearable
                dense
                autofocus
              ></v-text-field>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="mb-3">
        <v-col>
          <label for="">Account Type</label>

          <v-select
            v-model="formFields.accountType"
            :items="filteredDealerPa"
            item-title="BusinessName"
            item-value="PACode"
            label=""
            persistent-hint
            single-line
            clearable
            filterable
            :no-data-text="'Account Type'"
            :hint="
              formFields.accountType
                ? formFields.accountType
                : accountType
                  ? `${accountType.BusinessName}`
                  : ''
            "
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <label for="">
            {{ formFields.accountType == 'Ford Direct' ? 'Dealer PA*' : 'Dealer PA' }}
          </label>

          <v-text-field
            v-model="formFields.dealerPA"
            :label="formFields.accountType == 'Ford Direct' ? 'Dealer PA*' : 'Dealer PA'"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-checkbox
          v-model="formFields.isParent"
          label="Is Parent?"
          @change="clearClientOrParent"
        ></v-checkbox>
      </v-row>
      <v-row class="mb-2" v-if="!formFields.isParent">
        <v-col>
          <label for="">Client Name</label>

          <v-select
            v-model="formFields.parentAccount"
            :items="clients"
            label="Select Client*"
            placeholder="Select a client*"
            persistent-hint
            single-line
            clearable
            filterable
            :no-data-text="'No clients found'"
            :hint="selectedClient ? `${selectedClient.title}` : ''"
          ></v-select>
        </v-col>
      </v-row>

      <v-row v-else-if="formFields.isParent">
        <v-col cols="12" md="12">
          <label for="">Parent Account Name</label>

          <v-text-field
            v-model="formFields.parentAccount"
            label="Parent Account Name"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <label for="">Account ID</label>

          <v-text-field
            v-model="a5AccountInput"
            type="text"
            label="Account Id (a5Account)"
            required
            placeholder="Enter comma-separated numbers (e.g., 123,456,789)"
            @keydown="blockInvalidChars"
          />
        </v-col>
      </v-row>

      <v-row>
        <!-- Website URL -->
        <v-col cols="12" md="12">
          <label for="">Website URL</label>

          <v-text-field
            v-model="formFields.main_website"
            label="Website URL"
            :rules="[urlRule]"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-row>
          <v-col cols="12" md="12">
            <v-file-input label="Account Logo" accept="image/png" show-size
              @update:modelValue="handleFileChange" />
          </v-col>
        </v-row> -->
      <!-- Expansion Panels -->
      <v-row>
        <v-expansion-panels>
          <!-- Primary Contact Section -->
          <v-expansion-panel>
            <v-expansion-panel-title>Primary Contact</v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-col cols="12" md="8">
                <v-text-field v-model="formFields.primaryContact.name" label="Name"></v-text-field>
                <v-text-field
                  v-model="formFields.primaryContact.email"
                  label="Email"
                ></v-text-field>
                <v-text-field
                  v-model="formFields.primaryContact.phone"
                  label="Phone"
                ></v-text-field>
              </v-col>
            </v-expansion-panel-text>
          </v-expansion-panel>

          <!-- Billing Info Section -->
          <v-expansion-panel>
            <v-expansion-panel-title>Billing Info</v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-col cols="12" md="8">
                <v-text-field v-model="formFields.billing.name" label="Name"></v-text-field>
                <v-text-field
                  v-model.trim="formFields.billing.address_1"
                  label="Address 1*"
                  :rules="[billingRules.address_1]"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="formFields.billing.address_2"
                  label="Address2"
                ></v-text-field>
                <v-text-field
                  v-model.trim="formFields.billing.city"
                  label="City*"
                  :rules="[billingRules.city]"
                  required
                ></v-text-field>
                <v-text-field
                  v-model.trim="formFields.billing.state"
                  label="State*"
                  :rules="[billingRules.state]"
                  required
                ></v-text-field>
                <v-text-field
                  v-model.trim="formFields.billing.zip"
                  label="Zip*"
                  :rules="[billingRules.zip]"
                  required
                ></v-text-field>
              </v-col>
            </v-expansion-panel-text>
          </v-expansion-panel>

          <!-- Notes Section -->
          <v-expansion-panel>
            <v-expansion-panel-title>Notes</v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-col cols="12" md="12">
                <v-textarea label="Notes" v-model="formFields.notes"></v-textarea>
              </v-col>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-container>
  </v-form>

  <!-- Floating footer actions with fade-in -->
  <v-fade-transition>
    <div class="floating-footer">
      <v-container class="py-2 d-flex justify-end ga-2">
        <v-btn
          variant="text"
          color="grey-darken-1"
          class="mr-2"
          :disabled="props.isLoading || isLoading"
          @click="emit('cancel')"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="props.isLoading || isLoading"
          :loading="props.isLoading || isLoading"
          @click="onSave"
        >
          {{ props.isLoading || isLoading ? 'Creating Account...' : 'Submit' }}
        </v-btn>
      </v-container>
    </div>
  </v-fade-transition>
</template>

<script setup lang="ts">
import { useCreateAccountStore } from '@/stores/createAccountStore'
import { watch, ref, computed, onMounted, defineEmits } from 'vue'
import { countries, statesAndProvinces } from '@/data/countries'
import { fetchClients } from '@/api/accountsAdmin'
import logoPlaceholder from './logo-placeholder.png'
import { requiredTrimmedRule } from '@/utils/billingValidation'

const store = useCreateAccountStore()
const formFields = store.formFields

import { timeZones as region } from '@/views/timezoneData.js'
import { dealerships } from '@/views/PaCode.js'

const selectedCountry = ref({ name: 'United States of America', code: 'US' })
const selectedState = ref({ name: 'Select State*', code: '' })
const accountType = ref({ BusinessName: 'unspecified*', PACode: '' })
const selectedClient = ref({ title: 'Select Client*' })

const a5AccountInput = ref('')
const timeZones = ref(region)

const searchQuery = ref('')
const clients = ref([])
const searchQueryStates = ref('')
const searchQueryDealerPa = ref('')
const timezoneSearchQuery = ref('')
const isLoading = ref(false)
const formRef = ref()

const billingRules = {
  address_1: requiredTrimmedRule('Address 1'),
  city: requiredTrimmedRule('City'),
  state: requiredTrimmedRule('State'),
  zip: requiredTrimmedRule('Zip'),
}

const account_ford_direct = ref(false)

const emit = defineEmits<{
  (e: 'save'): void
  (e: 'cancel'): void
}>()

// Define props to receive loading state from parent
const props = defineProps<{
  isLoading?: boolean
}>()

const onSave = async () => {
  const { valid } = await formRef.value.validate()
  if (valid) emit('save')
}

watch(
  () => formFields.accountNameFriendly,
  (newValue) => {
    formFields.accountName = newValue
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }
)

watch(
  () => formFields.accountName,
  (newValue) => {
    formFields.accountNameFriendly = newValue

      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }
)

watch(
  () => formFields.accountName,
  (newValue) => {
    formFields.accountName = newValue.toLowerCase().replace(/[-\s]/g, '_')
  },
  { immediate: true }
)
watch(
  () => formFields.accountNameFriendly,
  (newValue) => {
    formFields.initials = threeWords(newValue)
  }
)
watch(
  () => formFields.accountNameFriendly,
  (newValue) => {
    formFields.parentAccount = newValue
  },
  { immediate: true }
)
function threeWords(string: string) {
  let str = string.toLowerCase().replace(/[^a-z0-9\s]/g, '')
  let modified = ''
  for (let i = 0; i < str.length; i++) {
    if (i === 0) {
      modified += str[i]
    } else if (
      str[i] === 'a' ||
      str[i] === 'e' ||
      str[i] === 'i' ||
      str[i] === 'o' ||
      str[i] === 'u'
    ) {
    } else if (str[i] === ' ') {
      // console.log('Irrelevant')
    } else if (modified.length < 3) {
      modified += str[i]
    }
  }
  return modified.toUpperCase()
}

const filteredCountries = computed(() => {
  if (!searchQuery.value) return countries
  return countries.filter((country) =>
    country.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const filteredStates = computed(() => {
  if (!searchQueryStates.value) return statesAndProvinces
  return statesAndProvinces.filter((state) =>
    state.name.toLowerCase().includes(searchQueryStates?.value?.toLowerCase())
  )
})
const filteredDealerPa = computed(() => {
  if (!searchQueryDealerPa.value) return dealerships
  return dealerships.filter((state) =>
    state.BusinessName.toLowerCase().includes(searchQueryDealerPa?.value?.toLowerCase())
  )
})

const loadData = async () => {
  console.log('hello')
  try {
    const res = await fetchClients()
    console.log(res)
    clients.value = res.map((client) => ({ title: client }))
  } catch (error) {
    console.error('Failed to load data:', error)
  } finally {
    console.log('data fetched')
  }
}

const tempFormField = ref('')
const clearClientOrParent = () => {
  if (formFields.isParent) {
    formFields.parentAccount = tempFormField.value
    formFields.clientId = ''
  } else {
    tempFormField.value = formFields.parentAccount
    formFields.parentAccount = ''
  }
}

watch(a5AccountInput, (newValue) => {
  const filtered = newValue.replace(/[^0-9,]/g, '')

  formFields.a5Account = filtered
    .split(',')
    .map((num) => num.trim())
    .filter((num) => num !== '')
    .map(Number)

  a5AccountInput.value = filtered
})

const blockInvalidChars = (event: KeyboardEvent) => {
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', ',']

  if (!/[\d,]/.test(event.key) && !allowedKeys.includes(event.key)) {
    event.preventDefault()
  }
}

const handleFileChange = (file: File | File[] | null) => {
  const MAX_SIZE_MB = 2 // Maximum file size in MB
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024 // Convert MB to bytes

  if (file instanceof File) {
    if (file.size > MAX_SIZE_BYTES) {
      alert(`File size exceeds ${MAX_SIZE_MB}MB. Please select a smaller file.`)
      return
    }
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      formFields.image = reader.result as string // Store Base64 string
    }
  } else if (Array.isArray(file) && file.length > 0) {
    const reader = new FileReader()
    reader.readAsDataURL(file[0])
    reader.onload = () => {
      formFields.image = reader.result as string
    }
  } else {
    formFields.image = ''
  }
}

const filteredTimezones = computed(() => {
  if (!timezoneSearchQuery.value) return timeZones.value
  return timeZones.value.filter((tz) =>
    tz.toLowerCase().includes(timezoneSearchQuery.value.toLowerCase())
  )
})

// URL validation rule (must start with http:// or https://)
const urlRule = (v) => {
  if (!v) return true // let `requiredRule` catch empty
  // basic URL regex — tweak as needed
  const pattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i
  return pattern.test(v) || 'Please enter a valid URL (must start with http:// or https://)'
}
onMounted(() => {
  loadData()
  // getFormattedTimezones();
})
</script>

<style scoped>
.v-expansion-panel-title {
  font-weight: bold;
}

.image-div {
  height: 60px;
  width: 60px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
}

.bg-logo {
  object-fit: contain;
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.plus-icon {
  z-index: 3;
  position: absolute;
  bottom: -4px;
  right: 10px;
  width: 24px;
  height: 24px;
  color: black;
  font-size: 25px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid #9acbd0;

  /* border:2px solid red; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-input-field {
  display: none;
}

.image-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-div {
  height: 60px;
  width: 60px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
}

.bg-logo {
  object-fit: contain;
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.plus-icon {
  z-index: 3;
  position: absolute;
  bottom: -4px;
  right: 10px;
  width: 24px;
  height: 24px;
  color: black;
  font-size: 25px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid #9acbd0;

  /* border:2px solid red; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-input-field {
  display: none;
}

.image-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-div {
  height: 60px;
  width: 60px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
}

.bg-logo {
  object-fit: contain;
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.plus-icon {
  z-index: 3;
  position: absolute;
  bottom: -4px;
  right: 10px;
  width: 24px;
  height: 24px;
  color: black;
  font-size: 25px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid #9acbd0;

  /* border:2px solid red; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-input-field {
  display: none;
}

.floating-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 10;
}
</style>
